import React, { useState } from 'react';
import { fetchYahoo, previewSession } from '../services/forecastClient';

const ForecastPage = () => {
  const [symbols, setSymbols] = useState('INFY,TCS');
  const [period, setPeriod] = useState('1mo');
  const [interval, setInterval] = useState('5m');
  const [resample, setResample] = useState('5T');
  const [sessionId, setSessionId] = useState(null);
  const [preview, setPreview] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleFetch = async () => {
    setLoading(true);
    setError('');
    try {
      const syms = symbols.split(',').map(s => s.trim()).filter(Boolean);
      const resp = await fetchYahoo({ symbols: syms, period, interval, resample });
      setSessionId(resp.data.session_id);
      const p = await previewSession(resp.data.session_id);
      setPreview(p.data);
    } catch (e) {
      setError(e.response?.data?.detail || e.message);
      setPreview([]);
      setSessionId(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ margin: 0, marginBottom: 12 }}>📈 Stock Forecast (Yahoo Finance)</h2>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, maxWidth: 800 }}>
        <input placeholder="Symbols (comma separated)" value={symbols} onChange={e => setSymbols(e.target.value)} />
        <select value={period} onChange={e => setPeriod(e.target.value)}>
          {['5d','1mo','3mo','6mo','1y','2y','5y'].map(p => <option key={p} value={p}>{p}</option>)}
        </select>
        <select value={interval} onChange={e => setInterval(e.target.value)}>
          {['1m','2m','5m','15m','30m','60m','1h','1d'].map(i => <option key={i} value={i}>{i}</option>)}
        </select>
        <select value={resample} onChange={e => setResample(e.target.value)}>
          {['1T','5T','15T','30T','60T','1D'].map(r => <option key={r} value={r}>{r}</option>)}
        </select>
        <button onClick={handleFetch} disabled={loading} style={{ gridColumn: 'span 2' }}>
          {loading ? 'Fetching…' : 'Fetch & Preview'}
        </button>
      </div>
      {error && <div style={{ marginTop: 10, color: '#b00020' }}>Error: {error}</div>}
      {sessionId && (
        <div style={{ marginTop: 16 }}>
          <div>Session: <code>{sessionId}</code></div>
          <div style={{ marginTop: 8 }}>
            <strong>Preview:</strong>
            <ul>
              {preview.map(p => (
                <li key={p.symbol}>{p.symbol}: {p.rows} rows</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForecastPage;


